function n(e) {
  return {
    name: "Test Anything Protocol",
    case_insensitive: !0,
    contains: [
      e.HASH_COMMENT_MODE,
      // version of format and total amount of testcases
      {
        className: "meta",
        variants: [
          { begin: "^TAP version (\\d+)$" },
          { begin: "^1\\.\\.(\\d+)$" }
        ]
      },
      // YAML block
      {
        begin: /---$/,
        end: "\\.\\.\\.$",
        subLanguage: "yaml",
        relevance: 0
      },
      // testcase number
      {
        className: "number",
        begin: " (\\d+) "
      },
      // testcase status and description
      {
        className: "symbol",
        variants: [
          { begin: "^ok" },
          { begin: "^not ok" }
        ]
      }
    ]
  };
}
export {
  n as default
};
